import { NgModule } from '@angular/core'

@NgModule()
export class ContactBoxModule {
}

export interface ContactDataBase {
  cityAndZip: string;
  company: string;
  country: string;
  email: string;
  fax: string;
  phone: string;
  street: string;
}

export function contactDataBaseConverter (contactData: any): ContactDataBase {
  return {
    company: contactData.gc_company?.value,
    country: contactData.gc_country?.value,
    email: contactData.gc_email?.value,
    fax: contactData.gc_orders_fax?.value,
    phone: contactData.gc_phone?.value,
    street: contactData.gc_street?.value,
    cityAndZip: contactData.gc_zip_city?.value
  }
}

export interface ContactDataTechnical {
  technicalPhone: string;
  technicalSupportChatAvailability: string;
  technicalSupportEmail: string;
  technicalSupportPhoneAvailability: string;
}

export function contactDataTechnicalConverter (contactData: any): ContactDataTechnical {
  return {
    technicalPhone: contactData?.gc_technical_phone?.value ?? '',
    technicalSupportChatAvailability: contactData?.gc_technical_support_chat_availability?.value ?? '',
    technicalSupportEmail: contactData?.gc_technical_support_email?.value ?? '',
    technicalSupportPhoneAvailability: contactData?.gc_technical_support_phone_availability?.value ?? '',
  }
}
